/* TEMPORARY COMPONENT AS PLACEHOLDER FOR AGENT/AGENCY PROFILE 2026 */

import React from 'react';
import * as styles from './profile-placeholder.style';

export interface ProfilePlaceholderProps {
  label: string;
  ticket?: string;
  detail?: string;
  width?: number;
  minHeight?: number;
}

const ProfilePlaceholder = ({
  label,
  ticket,
  detail,
  width,
  minHeight,
}: ProfilePlaceholderProps): JSX.Element => (
  <div
    css={styles.placeholder({ width, minHeight })}
    data-testid={`profile-2026__placeholder--${label
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')}`}
  >
    {detail && <span css={styles.detail}>{detail}</span>}
    <span css={styles.label}>{label}</span>
    {ticket && <span css={styles.ticket}>{ticket}</span>}
  </div>
);

export default ProfilePlaceholder;
